import { render, staticRenderFns } from "./OauthLogin.vue?vue&type=template&id=6a25ca1b&scoped=true"
import script from "./OauthLogin.vue?vue&type=script&lang=js"
export * from "./OauthLogin.vue?vue&type=script&lang=js"
import style0 from "./OauthLogin.vue?vue&type=style&index=0&id=6a25ca1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a25ca1b",
  null
  
)

export default component.exports